import PropTypes from 'prop-types';
import React from 'react';

import { AnnotationIcon } from '@heroicons/react/solid';
import noop from 'lodash/noop';

import Modal from 'components/Modal';
import Button from 'components/buttons/Button';

const CompanyQuoteDeleteModal = ({
  open = false,
  title = '',
  onClose = noop,
  onDelete = noop,
}) => (
  <Modal open={open}>
    <Modal.Icon Icon={AnnotationIcon} />
    <Modal.Title>Delete quote</Modal.Title>
    <Modal.Description>
      Are you sure you want to delete quote: <b>{title}</b>
    </Modal.Description>
    <Modal.RightButtons>
      <Button type="secondary" onClick={onClose}>
        Cancel
      </Button>
      <Button
        onClick={onDelete}
        eventType="pressPage_update"
        eventProperties={{ action: 'quote_delete' }}
        data-test-id="company-quotes-deleteModal-delete"
      >
        Delete quote
      </Button>
    </Modal.RightButtons>
  </Modal>
);

CompanyQuoteDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CompanyQuoteDeleteModal;
